import { render, staticRenderFns } from "./DeviceAssignmentForm.vue?vue&type=template&id=1bc49124&scoped=true&"
import script from "./DeviceAssignmentForm.vue?vue&type=script&lang=ts&"
export * from "./DeviceAssignmentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc49124",
  null
  
)

export default component.exports